export const languages = {
  ro: {
    // Locale BCP 47 pentru calendare (v-calendar / Intl): luni, zile, prima zi a săptămânii.
    locale: 'ro',
    mainMenu: {
      intrareNoua: 'Primește Mașina',
      intrari: 'Mașini în service',
      devize: 'Devize',
      clienti: 'Clienți',
      facturi: 'Facturi',
      masini: 'Istoric mașini',
      programari: 'Programări',
      links: 'Furnizori piese',
      setari: 'Setări',
      logout: 'Ieșire din cont',
    },
    days: [
      'Luni',
      'Marti',
      'Miercuri',
      'Joi',
      'Vineri',
      'Sâmbata',
      'Duminica'
    ],
    daysShort: [
      'Lu',
      'Ma',
      'Mi',
      'Jo',
      'Vi',
      'Sâ',
      'Du'
    ],
    months: [
      'ianuarie',
      'februarie',
      'martie',
      'aprilie',
      'mai',
      'iunie',
      'iulie',
      'august',
      'septembrie',
      'octombrie',
      'noiembrie',
      'decembrie'
    ],
    intrareNoua: 'Intrare nouă',
    clienti: 'Clienți',
    masini: 'Mașini',
    programareNoua: 'Adaugă o programare',
    programareNouaStepTitle: 'PROGRAMARE NOUĂ',
    editeazaProgramarea: 'Editează programarea',
    detaliiProgramarii: 'Detalii programare',
    programari: 'Programări',
    programariSchedule: {
      emptyDay: 'Nicio programare în această zi',
      noNotes: 'Fără observații',
      noDefectiuni: 'Nicio defecțiune raportată',
      noPieseClient: 'Fără piese client',
      close: 'Închide',
      todayBtn: 'Azi',
      searchPlaceholder: 'Nr. auto, nume sau marcă',
      clearBtn: 'sterge',
      clientLabel: 'Client',
      plateLabel: 'Nr. înmatriculare',
      carLabel: 'Mașină',
      notFilled: 'Necompletat',
      detailsTitle: 'Informații programare',
      selectedDateLabel: 'Data selectată',
      selectedTimeLabel: 'Ora selectată',
      searchNoResults: 'Niciun rezultat',
      createSuccessToast: 'Programare salvată cu succes',
      createdToastPrefix: 'Programare adăugată',
      movedToastPrefix: 'Programare mutată pe',
      updateSuccessToast: 'Programare actualizată',
      pastDateError: 'Nu poți crea o programare în trecut.',
      saveError: 'Eroare la salvarea programării. Încearcă din nou.',
      deleteSuccessToast: 'Programare ștearsă',
      deleteError: 'Eroare la ștergerea programării. Încearcă din nou.',
      deleteConfirmTitle: 'Ești sigur că vrei să ștergi această programare?',
      deleteConfirmMessage: 'Această acțiune nu poate fi anulată.',
      deleteConfirmCancel: 'Anulează',
      deleteConfirmConfirm: 'Da, șterge',
      searchResultsCount: '{count} programări găsite',
      discardChangesConfirm: 'Ai modificări nesalvate. Sigur vrei să renunți?'
    },
    programariCalendar: {
      weekViewLabel: 'Săptămână',
      monthViewLabel: 'Lună',
      moreCount: '+{count} mai multe',
      addPrompt: 'Vrei să adaugi o programare?',
      highlightBookedLabel: 'Evidențiază zilele cu programări'
    },
    date: 'Data',
    time: 'Ora',
    bookingChooseDay: 'Alege ziua',
    bookingChooseTime: 'Alege ora',
    bookingHourLabel: 'Ora',
    bookingMinuteLabel: 'Minute',
    bookingSummary: 'Programăm pentru {weekday}, {day} {month}, ora {time}',
    bookingSummaryEmpty: 'Nu ai ales încă data și ora',
    fieldRequired: 'Completează {field}',
    saveBtn: 'Salvează',
    saving: 'Se salvează...',
    quitBtn: 'Renunță',
    back: 'Înapoi',
    autoDetails: 'DETALII AUTO',
    clientDetails: 'DETALII CLIENT',
    repairsDetails: 'DETALII REPARAȚII',
    settings: {
      dateService: 'Date Service',
      conditiiContract: 'Adaugă condițiile contractului (pagina 2) la printare/PDF',
      pageTitle: 'SETĂRI',
      newBadge: 'Nou',
      tarife: 'tarife',
      rarAutopass: 'RAR Autopass',
      haynes: 'Haynes',
      logo: 'Logo',
      aspectDocumente: 'Aspect documente',
      logoUpload: 'Încarcă logo',
      logoDelete: 'Șterge logo',
      logoUploadSuccess: 'Logo încărcat cu succes.',
      logoUploadError: 'Eroare la încărcarea logo-ului.',
      logoDeleteSuccess: 'Logo-ul a fost șters.',
      logoDeleteError: 'Eroare la ștergerea logo-ului.',
      logoFileTooBig: 'Fișierul depășește limita de 2MB.',
      dimensiuneLogo: 'Dimensiune logo',
      opacitate: 'Opacitate',
      min: 'Min.',
      max: 'Max.',
      logoPlaceholder: 'LOGO',
      logoTopTitle: 'Adaugă logo sus',
      logoMiddleTitle: 'Adaugă logo mijloc',
      logoInvalidType: 'Format invalid. Folosește PNG, JPEG sau WebP.',
      watermarkUpload: 'Încarcă logo mijloc',
      watermarkDelete: 'Șterge logo mijloc',
      watermarkUploadSuccess: 'Logo-ul de mijloc a fost încărcat cu succes.',
      watermarkUploadError: 'Eroare la încărcarea logo-ului de mijloc.',
      watermarkDeleteSuccess: 'Logo-ul de mijloc a fost șters.',
      watermarkDeleteError: 'Eroare la ștergerea logo-ului de mijloc.',
      stergeLogoConfirm: 'Ștergi logo-ul?',
      stergeLogoMesaj: 'Această acțiune nu poate fi anulată.',
      da: 'Da',
      nu: 'Nu',
      smartbill: 'SmartBill',
      smartbill_save: 'Conectează SmartBill',
      smartbill_connecting: 'Se conectează...',
      smartbill_connected: 'Contul este conectat la SmartBill.',
      smartbill_disconnect: 'Deconectează SmartBill',
      smartbill_disconnect_title: 'Deconectare SmartBill',
      smartbill_disconnect_message: 'Sigur vrei să te deconectezi de la SmartBill?',
      smartbill_success: 'Conectare reușită la SmartBill.',
      smartbill_error_email: 'Adresa de email nu este validă.',
      smartbill_error_default: 'Credențiale invalide.',
      oblio: 'Oblio',
      oblio_save: 'Conectează Oblio',
      oblio_connecting: 'Se conectează...',
      oblio_connected: 'Contul este conectat la Oblio.',
      oblio_disconnect: 'Deconectează Oblio',
      oblio_success: 'Conectare reușită la Oblio.',
      oblio_error_email: 'Adresa de email nu este validă.',
      oblio_error_default: 'Credențiale invalide.',
      oblio_error_cui: 'Completează mai întâi CUI-ul firmei în Date Service.',
      version: 'Versiune',
      documentUploadSuccess: 'Document încărcat cu succes.',
      documentUploadError: 'Eroare la încărcarea documentului.',
      documentFileTooBig: 'Fișierul depășește limita de 10MB.',
      documentInvalidType: 'Format invalid. Folosește PDF, DOC sau DOCX.',
      currentPasswordLabel: 'Parola actuală',
      newPasswordLabel: 'Parolă nouă',
      confirmPasswordLabel: 'Confirmă parola nouă',
      changePasswordBtn: 'Schimbă parola',
      changePasswordSaving: 'Se schimbă...',
      changePasswordSuccess: 'Parola a fost schimbată cu succes.',
      changePasswordRequired: 'Completează toate câmpurile.',
      changePasswordTooShort: 'Parola nouă trebuie să aibă minimum 8 caractere.',
      changePasswordMismatch: 'Parolele noi nu coincid.',
      changePasswordSameAsCurrent: 'Parola nouă trebuie să fie diferită de parola actuală.',
      changePasswordIncorrectCurrent: 'Parola actuală este incorectă.',
      changePasswordGenericError: 'Eroare la schimbarea parolei. Încearcă din nou.',
      securityTitle: 'Schimbă parola',
      securitySubtitle: 'Alege o parolă nouă de minimum 8 caractere, diferită de cea actuală, ca să-ți menții contul în siguranță.'
    },
    haynes_status: {
      scraping: 'Se sincronizează Haynes...',
      success: 'Sincronizarea Haynes s-a făcut cu succes',
      not_found: 'Fără date Haynes pentru acest VIN / cod motor',
      error: 'Serviciul Haynes momentan indisponibil',
      missing_vin: 'Adăugați seria de caroserie (VIN) pentru sincronizare Haynes',
      missing_cod_motor: 'Adăugați codul de motor pentru sincronizare Haynes',
      missing_car_params: 'Adăugați seria de caroserie (VIN) și codul de motor pentru sincronizare Haynes'
    },
    general: 'general',
    language: 'Limbă',
    search: 'Caută după număr, mașină, client',
    car: 'car', // this is for icon
    nrCrt: 'Nr.',
    nrAuto: 'NUMĂR',
    marca: 'Marcă',
    model: 'Model',
    masina: 'Mașină',
    culoare: 'Culoare',
    telefon: 'telefon',
    observatii: 'observații',
    numar: 'Număr',
    serie: 'Serie',
    nrFactura: 'Nr.',
    dataEmiterii: 'Data emiterii',
    dataScadentei: 'Data scadenței',
    suma: 'Sumă',
    preview: 'Preview',
    data: 'Data',
    rar: 'RAR',
    sasiu: 'Șasiu',
    km: 'Km',
    carburant: 'Carburant',
    cilindree: 'Cilindree',
    putere: 'Putere',
    cod_motor: 'Cod motor',
    an: 'An',
    itp: 'ITP',
    asigurare: 'Asigurare',
    vehicul: 'Vehicul',
    detaliiAuto: 'DETALII AUTO',
    detaliiClient: 'DETALII CLIENT',
    detaliiReparatii: 'DETALII REPARAȚII',
    client: {
      nume: 'Nume',
      proprietar: 'Proprietar',
      telefon: 'Telefon',
      email: 'Email',
      numeFirma: 'Nume firmă',
      cui: 'C.U.I.',
      adresaFirma: 'Adresă',
      city: 'Oraș',
      state: 'Județ',
    },
    cerinteClient: 'Cerințe client',
    defectiuni: 'Defecțiuni',
    operatiuni: 'Operațiuni',
    pieseClient: 'Piese client',
    alocare: 'ALOCARE',
    detaliiRampa: 'DETALII RAMPĂ',
    mecanicAlocat: 'Mecanic alocat',
    alegeMecanic: 'Alege mecanic',
    rampaAlocata: 'Rampă alocată',
    alegeRampa: 'Alege rampă',
    rampa: 'Rampă',
    statusComanda: 'Status',
    alegeStatus: 'Alege status',
    statusNone: 'Fără status',
    statusMenuEmpty: 'Niciun status configurat.',
    statusMenuEmptyCta: 'Adaugă în Setări → Mecanici',
    comanda: 'Comandă',
    deviz: 'Deviz Final',
    deviz_oferta: 'Deviz Estimativ',
    devize: {
      pageTitle: 'Devize',
      pageSubtitle: 'Lista cu toate devizele emise și posibilitatea de trimitere către RAR AutoPass',
    },
    devize_empty: {
      no_devize_title: 'Nu ai încă niciun deviz',
      no_devize_subtitle: 'Devizele salvate vor apărea aici.',
      no_results_title: 'Niciun rezultat',
      no_results_subtitle: 'Ajustează filtrele sau caută altceva.',
    },
    raport_lunar: {
      button_label: 'Raport lunar',
      month_label: 'Lună',
      year_label: 'An',
      download_btn: 'Descarcă PDF',
      downloading_label: 'Se generează…',
      error: 'Eroare la generarea raportului.',
    },
    clienti: {
      pageTitle: 'Clienți',
      pageSubtitle: 'Caută, adaugă sau scanează cartea de identitate pentru a completa automat datele.',
    },
    facturi: {
      pageTitle: 'Facturi',
      pageSubtitle: 'Lista facturilor emise.',
      emitTitle: 'Emite factură SmartBill',
      dueDateLabel: 'Data scadenței',
      cancel: 'Anulează',
      emitCta: 'Emite factura',
      emitting: 'Se emite...',
      emitSuccess: 'Factura a fost emisă cu succes. Apasă pentru a o vedea.',
      emptyInvoiceError: 'Nu putem emite o factură goală. Adaugă cel puțin un articol în deviz.',
      emptyInvoiceTitle: 'Deviz gol',
      emptyInvoiceCta: 'Am înțeles',
    },
    comenzi: {
      pageTitle: 'Mașini în service',
      pageSubtitle: 'Lista cu toate mașinile care au intrat în service',
      detailObservatii: 'Observații',
      detailRamp: 'Rampă',
      detailMechanic: 'Mecanic atribuit',
      observatiiUnset: 'Fără observații',
      observatiiSeeMore: 'Vezi tot',
      observatiiSeeLess: 'Vezi mai puțin',
      rampUnset: 'Nealocată',
      mechanicUnset: 'Neatribuit',
    },
    comenzi_empty: {
      no_results_title: 'Niciun rezultat',
      no_results_subtitle: 'Nu am găsit intrări pentru căutarea ta. Încearcă alt termen.',
    },
    links: {
      pageTitle: 'Furnizori piese',
      pageSubtitle: 'Salvează și accesează rapid site-urile furnizorilor de piese pe care îi folosești.',
      add_cta: 'Adaugă furnizor',
      empty_title: 'Nu ai adăugat încă niciun link',
      empty_subtitle: 'Salvează aici scurtături către site-urile pe care le folosești zilnic.',
      empty_cta: 'Adaugă primul link',
      add_aria: 'Adaugă link',
      edit_aria: 'Editează link',
      title_label: 'Titlu',
      url_label: 'Adresa URL',
    },
    firma: 'firma',
    reset: 'Resetează',
    devizReset: {
      title: 'Resetează devizul',
      message: 'Ești sigur că vrei să resetezi devizul? Toate articolele vor fi șterse, iar devizul va fi salvat gol. Această acțiune nu poate fi anulată.',
      confirm: 'Resetează',
    },
    devizMobile: {
      totalFaraTva: 'Total fără TVA',
      totalTva: 'TVA',
      codPlaceholder: 'Cod piesă',
      denumire: 'DENUMIRE',
      cod: 'COD',
      stergeRand: {
        title: 'Șterge articolul',
        message: {
          manopera: 'Ești sigur că vrei să ștergi acest articol din manoperă? Această acțiune este ireversibilă.',
          parts: 'Ești sigur că vrei să ștergi acest articol din piese? Această acțiune este ireversibilă.',
          materiale: 'Ești sigur că vrei să ștergi acest articol din materiale? Această acțiune este ireversibilă.',
        },
        confirm: 'Șterge',
      },
    },
    intrareRenunta: {
      title: 'Renunță la intrare',
      message: 'Ești sigur că vrei să renunți? Modificările nesalvate se vor pierde.',
      confirm: 'Renunță',
    },
    comandaSterge: {
      title: 'Șterge comanda',
      message: 'Ești sigur că vrei să ștergi comanda? Această acțiune nu poate fi anulată.',
      confirm: 'Șterge',
    },
    cuiSuprascrie: {
      title: 'Suprascrii datele firmei?',
      message: 'Ai completat deja date despre firmă. Căutarea după CUI le va înlocui. Continui?',
      confirm: 'Suprascrie',
    },
    invoice: 'Factură',
    print: 'Print',
    delete: 'Șterge',
    errors: {
      cui_lookup_not_found: 'CUI negăsit',
      cui_lookup_failed: 'Eroare la căutare CUI',
      cui_lookup_success: 'Date firmă preluate cu succes',
      cui_lookup_timeout: 'Căutarea CUI a expirat. Încearcă din nou.'
    },
    auth_error: {
      invalid_credentials: 'Utilizator sau parolă incorectă.',
      account_blocked: 'Contul este blocat sau expirat. Vă rugăm să contactați administratorul.',
      too_many_attempts: 'Prea multe încercări de autentificare. Încercați din nou mai târziu.',
      unknown: 'A apărut o eroare neașteptată. Vă rugăm să încercați din nou.'
    },
    auth: {
      loginTitle: 'Bine ai revenit',
      loginSubtitle: 'Conectează-te pentru a-ți gestiona comenzile și devizele.',
      loginSubmitBtn: 'Intră în cont',
      passwordLabel: 'Parolă',
      passwordPlaceholder: 'Parola ta',
      forgotPasswordLink: 'Am uitat parola',
      emailLabel: 'Email',
      emailPlaceholder: 'Email',
      backToLogin: 'Înapoi la autentificare',
      forgotPasswordTitle: 'Resetare parolă',
      forgotPasswordSubtitle: 'Introdu adresa de email a contului și îți trimitem un link de resetare.',
      forgotPasswordSubmitBtn: 'Trimite link de resetare',
      forgotPasswordSending: 'Se trimite...',
      forgotPasswordRequired: 'Introdu adresa de email.',
      forgotPasswordInvalidEmail: 'Adresa de email nu este validă.',
      forgotPasswordGenericError: 'A apărut o eroare. Încearcă din nou.',
      resetPasswordTitle: 'Setează o parolă nouă',
      resetPasswordNewPasswordLabel: 'Parolă nouă',
      resetPasswordConfirmPasswordLabel: 'Confirmă parola nouă',
      resetPasswordSubmitBtn: 'Resetează parola',
      resetPasswordSaving: 'Se resetează...',
      resetPasswordSuccess: 'Parola a fost resetată cu succes.',
      resetPasswordRequired: 'Completează toate câmpurile.',
      resetPasswordTooShort: 'Parola nouă trebuie să aibă minimum 8 caractere.',
      resetPasswordMismatch: 'Parolele nu coincid.',
      resetPasswordGenericError: 'Eroare la resetarea parolei. Încearcă din nou.',
      resetPasswordInvalidTitle: 'Link invalid',
      resetPasswordInvalidMessage: 'Link invalid sau expirat. Cere un link nou de resetare.',
      requestNewLinkBtn: 'Cere un link nou'
    },
  },
  se: {
    // Cheia `se` e Svenska; codul de limbă pentru suedeză e `sv` (`se` = sami de nord).
    locale: 'sv',
    mainMenu: {
      intrareNoua: 'Ny inkommande',
      intrari: 'Inkommande',
      clienti: 'Kunder',
      facturi: 'Fakturor',
      masini: 'Fordon',
      programari: 'Bokningar',
      links: 'Länkar',
      setari: 'Inställningar',
      logout: 'Logga ut',
    },
    daysShort: [
      'mån',
      'tis',
      'ons',
      'tors',
      'fre',
      'lör',
      'sön'
    ],
    days: [
      'måndag',
      'tisdag',
      'onsdag',
      'torsdag',
      'fredag',
      'lördag',
      'söndag'
    ],
    months: [
      'januari',
      'februari',
      'mars',
      'april',
      'maj',
      'juni',
      'juli',
      'augusti',
      'september',
      'oktober',
      'november',
      'december'
    ],
    intrareNoua: 'Ny inkommande',
    programareNoua: 'Lägg till bokning',
    programareNouaStepTitle: 'NY BOKNING',
    editeazaProgramarea: 'Redigera bokningen',
    detaliiProgramarii: 'Bokningsdetaljer',
    programari: 'Bokningar',
    programariSchedule: {
      emptyDay: 'Inga bokningar denna dag',
      noNotes: 'Inga anteckningar',
      noDefectiuni: 'Inga rapporterade fel',
      noPieseClient: 'Inga kunddelar',
      close: 'Stäng',
      todayBtn: 'Idag',
      searchPlaceholder: 'Sök reg.nr, namn eller märke',
      clearBtn: 'Rensa',
      clientLabel: 'Kund',
      plateLabel: 'Reg.nr',
      carLabel: 'Fordon',
      notFilled: 'Ej ifyllt',
      detailsTitle: 'Bokningsinformation',
      selectedDateLabel: 'Valt datum',
      selectedTimeLabel: 'Vald tid',
      searchNoResults: 'Inga resultat',
      createSuccessToast: 'Bokningen sparades',
      createdToastPrefix: 'Bokning tillagd',
      movedToastPrefix: 'Bokning flyttad till',
      updateSuccessToast: 'Bokningen uppdaterades',
      pastDateError: 'Du kan inte skapa en bokning i det förflutna.',
      saveError: 'Det gick inte att spara bokningen. Försök igen.',
      deleteSuccessToast: 'Bokningen togs bort',
      deleteError: 'Det gick inte att ta bort bokningen. Försök igen.',
      deleteConfirmTitle: 'Är du säker på att du vill ta bort den här bokningen?',
      deleteConfirmMessage: 'Denna åtgärd kan inte ångras.',
      deleteConfirmCancel: 'Avbryt',
      deleteConfirmConfirm: 'Ja, ta bort',
      searchResultsCount: '{count} bokningar hittades',
      discardChangesConfirm: 'Du har osparade ändringar. Vill du verkligen avbryta?'
    },
    programariCalendar: {
      weekViewLabel: 'Vecka',
      monthViewLabel: 'Månad',
      moreCount: '+{count} till',
      addPrompt: 'Vill du lägga till en bokning?',
      highlightBookedLabel: 'Markera dagar med bokningar'
    },
    date: 'Datum',
    time: 'Tid',
    bookingChooseDay: 'Välj dag',
    bookingChooseTime: 'Välj tid',
    bookingHourLabel: 'Timme',
    bookingMinuteLabel: 'Minuter',
    bookingSummary: 'Vi bokar {weekday} {day} {month}, kl. {time}',
    bookingSummaryEmpty: 'Du har inte valt datum och tid ännu',
    fieldRequired: 'Fyll i {field}',
    saveBtn: 'Spara',
    saving: 'Sparar...',
    quitBtn: 'Stäng',
    back: 'Tillbaka',
    autoDetails: 'FORDONSDETALJER',
    clientDetails: 'KUNDDETALJER',
    repairsDetails: 'REPARATIONSDETALJER',
    settings: {
      dateService: 'Företagsuppgifter',
      conditiiContract: 'Lägg till avtalsvillkoren (sida 2) vid utskrift/PDF',
      pageTitle: 'inställningar',
      newBadge: 'Nytt',
      tarife: 'tariff',
      rarAutopass: 'RAR Autopass',
      haynes: 'Haynes',
      logo: 'Logotyp',
      logoUpload: 'Ladda upp logotyp',
      aspectDocumente: 'Dokumentutseende',
      logoDelete: 'Ta bort logotyp',
      logoUploadSuccess: 'Logotypen har laddats upp.',
      logoUploadError: 'Fel vid uppladdning av logotyp.',
      logoDeleteSuccess: 'Logotypen har tagits bort.',
      logoDeleteError: 'Fel vid borttagning av logotyp.',
      logoFileTooBig: 'Filen överskrider gränsen på 2MB.',
      dimensiuneLogo: 'Logostorlek',
      opacitate: 'Opacitet',
      min: 'Min.',
      max: 'Max.',
      logoPlaceholder: 'LOGO',
      logoTopTitle: 'Lägg till övre logotyp',
      logoMiddleTitle: 'Lägg till logotyp i mitten',
      logoInvalidType: 'Ogiltigt format. Använd PNG, JPEG eller WebP.',
      watermarkUpload: 'Ladda upp mittlogotyp',
      watermarkDelete: 'Ta bort mittlogotyp',
      watermarkUploadSuccess: 'Mittlogotypen har laddats upp.',
      watermarkUploadError: 'Fel vid uppladdning av mittlogotyp.',
      watermarkDeleteSuccess: 'Mittlogotypen har tagits bort.',
      watermarkDeleteError: 'Fel vid borttagning av mittlogotyp.',
      stergeLogoConfirm: 'Ta bort logotypen?',
      stergeLogoMesaj: 'Den här åtgärden kan inte ångras.',
      da: 'Ja',
      nu: 'Nej',
      smartbill: 'SmartBill',
      smartbill_save: 'Anslut SmartBill',
      smartbill_connecting: 'Ansluter...',
      smartbill_connected: 'Kontot är anslutet till SmartBill.',
      smartbill_disconnect: 'Koppla från SmartBill',
      smartbill_disconnect_title: 'Koppla från SmartBill',
      smartbill_disconnect_message: 'Är du säker på att du vill koppla från SmartBill?',
      smartbill_success: 'Anslutning till SmartBill lyckades.',
      smartbill_error_email: 'E-postadressen är inte giltig.',
      smartbill_error_default: 'Ogiltiga uppgifter.',
      oblio: 'Oblio',
      oblio_save: 'Anslut Oblio',
      oblio_connecting: 'Ansluter...',
      oblio_connected: 'Kontot är anslutet till Oblio.',
      oblio_disconnect: 'Koppla från Oblio',
      oblio_success: 'Anslutning till Oblio lyckades.',
      oblio_error_email: 'E-postadressen är inte giltig.',
      oblio_error_default: 'Ogiltiga uppgifter.',
      oblio_error_cui: 'Fyll först i företagets CUI i Date Service.',
      version: 'Version',
      documentUploadBtn: 'Dokument',
      documentUploadSuccess: 'Dokumentet har laddats upp.',
      documentUploadError: 'Fel vid uppladdning av dokumentet.',
      documentFileTooBig: 'Filen överskrider gränsen på 10MB.',
      documentInvalidType: 'Ogiltigt format. Använd PDF, DOC eller DOCX.',
      currentPasswordLabel: 'Nuvarande lösenord',
      newPasswordLabel: 'Nytt lösenord',
      confirmPasswordLabel: 'Bekräfta nytt lösenord',
      changePasswordBtn: 'Byt lösenord',
      changePasswordSaving: 'Byter...',
      changePasswordSuccess: 'Lösenordet har ändrats.',
      changePasswordRequired: 'Fyll i alla fält.',
      changePasswordTooShort: 'Det nya lösenordet måste vara minst 8 tecken.',
      changePasswordMismatch: 'De nya lösenorden matchar inte.',
      changePasswordSameAsCurrent: 'Det nya lösenordet måste skilja sig från det nuvarande.',
      changePasswordIncorrectCurrent: 'Nuvarande lösenord är felaktigt.',
      changePasswordGenericError: 'Fel vid byte av lösenord. Försök igen.',
      securityTitle: 'Byt lösenord',
      securitySubtitle: 'Välj ett nytt lösenord på minst 8 tecken, annat än det nuvarande, för att hålla ditt konto säkert.'
    },
    haynes_status: {
      scraping: 'Synkroniserar Haynes...',
      success: 'Haynes-synkroniseringen lyckades',
      not_found: 'Inga Haynes-data för detta chassinummer / motorkod',
      error: 'Haynes-tjänsten är för närvarande otillgänglig',
      missing_vin: 'Lägg till chassinummer (VIN) för Haynes-synkronisering',
      missing_cod_motor: 'Lägg till motorkod för Haynes-synkronisering',
      missing_car_params: 'Lägg till chassinummer (VIN) och motorkod för Haynes-synkronisering'
    },
    general: 'Allmänna inställningar',
    language: 'språk',
    search: 'Sök efter nummer, bil, kund',
    car: 'car', // this is for icon
    nrCrt: 'Nu.',
    nrAuto: 'Registreringsnummer',
    marca: 'Märke',
    model: 'Modell',
    masina: 'Fordon',
    culoare: 'Färg',
    telefon: 'Telefon',
    observatii: 'Anmärkningar',
    numar: 'Nummer',
    serie: 'Serie',
    nrFactura: 'Nr.',
    dataEmiterii: 'Utfärdandedatum',
    dataScadentei: 'Förfallodatum',
    suma: 'Belopp',
    preview: 'Förhandsvisning',
    data: 'Datum',
    rar: 'RAR',
    sasiu: 'Chassinummer',
    km: 'Mätarställning',
    carburant: 'Bränsle',
    cilindree: 'Motorvolym',
    putere: 'Effekt',
    cod_motor: 'Motorkod',
    an: 'Årsmodell',
    itp: 'Besiktning',
    asigurare: 'Försäkring',
    detaliiAuto: 'FORDONSDETALJER',
    detaliiClient: 'KUNDDETALJER',
    detaliiReparatii: 'Reparationsdetaljer',
    client: {
      nume: 'Namn',
      proprietar: 'Ägare',
      telefon: 'Telefon',
      email: 'E-post',
      numeFirma: 'Företagsnamn',
      cui: 'Organisationsnummer',
      adresaFirma: 'Företagsadress'
    },
    cerinteClient: 'Kundkrav',
    defectiuni: 'Fel',
    pieseClient: 'Kunddelar',
    alocare: 'TILLDELNING',
    detaliiRampa: 'RAMPDETALJER',
    mecanicAlocat: 'Tilldelad mekaniker',
    alegeMecanic: 'Välj mekaniker',
    rampaAlocata: 'Tilldelad ramp',
    alegeRampa: 'Välj ramp',
    rampa: 'Ramp',
    statusComanda: 'Status',
    alegeStatus: 'Välj status',
    statusNone: 'Ingen status',
    statusMenuEmpty: 'Ingen status konfigurerad.',
    statusMenuEmptyCta: 'Lägg till i Inställningar → Mekaniker',
    comanda: 'Arbetsorder',
    deviz: 'Kostnadsförslag',
    devize: {
      pageTitle: 'Kostnadsförslag',
      pageSubtitle: 'Lista över alla kostnadsförslag och möjligheten att skicka dem till RAR AutoPass',
    },
    devize_empty: {
      no_devize_title: 'Du har inga kostnadsförslag ännu',
      no_devize_subtitle: 'Sparade kostnadsförslag visas här.',
      no_results_title: 'Inga resultat',
      no_results_subtitle: 'Justera filtren eller sök efter något annat.',
    },
    raport_lunar: {
      button_label: 'Månadsrapport',
      month_label: 'Månad',
      year_label: 'År',
      download_btn: 'Ladda ner PDF',
      downloading_label: 'Genererar…',
      error: 'Fel vid generering av rapport.',
    },
    clienti: {
      pageTitle: 'Kunder',
      pageSubtitle: 'Alla dina kunder på ett ställe. Sök, lägg till eller skanna ett ID-kort för automatisk ifyllnad.',
    },
    devizReset: {
      title: 'Återställ kostnadsförslaget',
      message: 'Är du säker på att du vill återställa kostnadsförslaget? Alla rader tas bort och förslaget sparas tomt. Denna åtgärd kan inte ångras.',
      confirm: 'Återställ',
    },
    devizMobile: {
      totalFaraTva: 'Exkl. moms',
      totalTva: 'Moms',
      codPlaceholder: 'Kod',
      denumire: 'BENÄMNING',
      cod: 'KOD',
      stergeRand: {
        title: 'Ta bort raden',
        message: {
          manopera: 'Är du säker på att du vill ta bort den här raden från arbete? Denna åtgärd kan inte ångras.',
          parts: 'Är du säker på att du vill ta bort den här raden från delar? Denna åtgärd kan inte ångras.',
          materiale: 'Är du säker på att du vill ta bort den här raden från material? Denna åtgärd kan inte ångras.',
        },
        confirm: 'Ta bort',
      },
    },
    intrareRenunta: {
      title: 'Avbryt inmatning',
      message: 'Är du säker på att du vill avbryta? Osparade ändringar går förlorade.',
      confirm: 'Avbryt',
    },
    comandaSterge: {
      title: 'Ta bort order',
      message: 'Är du säker på att du vill ta bort ordern? Denna åtgärd kan inte ångras.',
      confirm: 'Ta bort',
    },
    cuiSuprascrie: {
      title: 'Skriva över företagsuppgifter?',
      message: 'Du har redan fyllt i företagsuppgifter. Sökningen på organisationsnummer ersätter dem. Fortsätta?',
      confirm: 'Skriv över',
    },
    facturi: {
      pageTitle: 'Fakturor',
      pageSubtitle: 'Lista över utfärdade fakturor.',
      emitTitle: 'Utfärda SmartBill-faktura',
      dueDateLabel: 'Förfallodatum',
      cancel: 'Avbryt',
      emitCta: 'Utfärda faktura',
      emitting: 'Utfärdar...',
      emitSuccess: 'Fakturan har utfärdats. Klicka för att visa den.',
      emptyInvoiceError: 'Vi kan inte utfärda en tom faktura. Lägg till minst en rad i offerten.',
      emptyInvoiceTitle: 'Tom offert',
      emptyInvoiceCta: 'Jag förstår',
    },
    comenzi: {
      pageTitle: 'Fordon i verkstad',
      pageSubtitle: 'Lista över alla fordon som kommit in på verkstaden',
      detailObservatii: 'Anmärkningar',
      detailRamp: 'Ramp',
      detailMechanic: 'Tilldelad mekaniker',
      observatiiUnset: 'Inga anmärkningar',
      observatiiSeeMore: 'Visa allt',
      observatiiSeeLess: 'Visa mindre',
      rampUnset: 'Ej angiven',
      mechanicUnset: 'Ej tilldelad',
    },
    comenzi_empty: {
      no_results_title: 'Inga resultat',
      no_results_subtitle: 'Vi hittade inga poster för din sökning. Prova ett annat sökord.',
    },
    links: {
      pageTitle: 'Reservdelsleverantörer',
      pageSubtitle: 'Spara och nå snabbt webbplatserna för de reservdelsleverantörer du använder.',
      add_cta: 'Lägg till leverantör',
      empty_title: 'Du har inte lagt till några länkar ännu',
      empty_subtitle: 'Spara genvägar till webbplatser du använder dagligen här.',
      empty_cta: 'Lägg till första länken',
      add_aria: 'Lägg till länk',
      edit_aria: 'Redigera länk',
      title_label: 'Titel',
      url_label: 'URL-adress',
    },
    errors: {
      cui_lookup_not_found: 'Organisationsnummer hittades inte',
      cui_lookup_failed: 'Fel vid sökning av organisationsnummer',
      cui_lookup_success: 'Företagsuppgifter hämtades',
      cui_lookup_timeout: 'Sökningen tog för lång tid. Försök igen.'
    },
    auth_error: {
      invalid_credentials: 'Felaktigt användarnamn eller lösenord.',
      account_blocked: 'Kontot är blockerat eller har gått ut. Kontakta administratören.',
      too_many_attempts: 'För många inloggningsförsök. Försök igen senare.',
      unknown: 'Ett oväntat fel inträffade. Försök igen senare.'
    },
    auth: {
      loginTitle: 'Välkommen tillbaka',
      loginSubtitle: 'Logga in för att hantera dina ordrar och offerter.',
      loginSubmitBtn: 'Logga in',
      passwordLabel: 'Lösenord',
      passwordPlaceholder: 'Ditt lösenord',
      forgotPasswordLink: 'Glömt lösenordet',
      emailLabel: 'E-post',
      emailPlaceholder: 'Email',
      backToLogin: 'Tillbaka till inloggning',
      forgotPasswordTitle: 'Återställ lösenord',
      forgotPasswordSubtitle: 'Ange kontots e-postadress så skickar vi en återställningslänk.',
      forgotPasswordSubmitBtn: 'Skicka återställningslänk',
      forgotPasswordSending: 'Skickar...',
      forgotPasswordRequired: 'Ange din e-postadress.',
      forgotPasswordInvalidEmail: 'E-postadressen är inte giltig.',
      forgotPasswordGenericError: 'Ett fel uppstod. Försök igen.',
      resetPasswordTitle: 'Ange ett nytt lösenord',
      resetPasswordNewPasswordLabel: 'Nytt lösenord',
      resetPasswordConfirmPasswordLabel: 'Bekräfta nytt lösenord',
      resetPasswordSubmitBtn: 'Återställ lösenord',
      resetPasswordSaving: 'Återställer...',
      resetPasswordSuccess: 'Lösenordet har återställts.',
      resetPasswordRequired: 'Fyll i alla fält.',
      resetPasswordTooShort: 'Det nya lösenordet måste vara minst 8 tecken.',
      resetPasswordMismatch: 'Lösenorden matchar inte.',
      resetPasswordGenericError: 'Fel vid återställning av lösenord. Försök igen.',
      resetPasswordInvalidTitle: 'Ogiltig länk',
      resetPasswordInvalidMessage: 'Länken är ogiltig eller har gått ut. Begär en ny återställningslänk.',
      requestNewLinkBtn: 'Begär en ny länk'
    }
  }
}